import actions from "../../constants/actions";

export const loadActiveOpenCalls = () => {
    return {
        type: actions.OPEN_CALLS.LOAD_ACTIVE,
        payload: {},
    };
};

export const loadOpenCallApplications = () => {
    return {
        type: actions.OPEN_CALLS.LOAD_APPLICATIONS,
        payload: {},
    };
};

export const addOpenCallApplications = (id, data) => {
    return {
        type: actions.OPEN_CALLS.CREATE_APPLICATIONS,
        payload: {
            id,
            data,
        },
    };
};

export const addOpenCallDynamicApplications = (id, data) => {
    return {
        type: actions.OPEN_CALLS.CREATE_DYNAMIC_APPLICATIONS,
        payload: {
            id,
            data,
        },
    };
};